export default[
    {
        path: '/dataList/reportElectronMember',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '电子总账',
            authLogin: true
        }
    }
]